import { ScriptableContext } from 'chart.js'
import clamp from '../math/clamp'
import normalizeNumber from '../math/normalizeNumber'

const getBackgroundColor = (ctx: ScriptableContext<'line'>, maxValue: number) => {
	const { chart } = ctx
	const { ctx: canvas, chartArea } = chart

	if (!chartArea) return 'transparent'

	const yScale = chart.scales.y

	if (
		!yScale ||
		typeof yScale.min !== 'number' ||
		typeof yScale.max !== 'number' ||
		isNaN(yScale.min) ||
		isNaN(yScale.max)
	) {
		return 'transparent'
	}

	const { min, max } = yScale.getMinMax(true)

	const minPixel = yScale.getPixelForValue(min)
	const maxPixel = yScale.getPixelForValue(max)

	const stop = (v: number) => clamp(normalizeNumber(v, min, max))

	const gradient = canvas.createLinearGradient(0, minPixel, 0, maxPixel)

	gradient.addColorStop(0, 'transparent')
	gradient.addColorStop(stop(maxValue - 125), 'transparent')
	gradient.addColorStop(stop(maxValue - 125), 'rgba(255, 179, 13, 0)')
	gradient.addColorStop(stop(maxValue - 75), 'rgba(255, 179, 13, 0.1)')
	gradient.addColorStop(stop(maxValue - 25), 'rgba(255, 179, 13, 0.24)')
	gradient.addColorStop(stop(maxValue), 'rgba(255, 179, 13, 0.5)')
	gradient.addColorStop(1, 'transparent')

	return gradient
}

export default getBackgroundColor
